import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

const fn = function ($filter, $scope, ClaimService, $state, $stateParams, $location, InsuranceSuiteMetadata, claimDetailsLinks, NavigationService, ServiceRequestService, ModalService) {
    const claimStateTypelist = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState');
    const claimOpen = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState').getCode('open').code;
    const claimClosed = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState').getCode('closed').code;
    const contactRoleTypelist = InsuranceSuiteMetadata.get('cc').types.getTypelist('ContactRole');
    const coverageTypeTypelist = InsuranceSuiteMetadata.get('cc').types.getTypelist('CoverageType');
    const makeTypelistPSA = InsuranceSuiteMetadata.get('cc').types.getTypelist('VehicleManufacturer');
    const causeSubgroupTypelistPSA = InsuranceSuiteMetadata.get('cc').types.getTypelist('CausesSubgroup_PSA');
    const defaultSubgroupTypelistPSA = InsuranceSuiteMetadata.get('cc').types.getTypelist('DefaultSubgroup_PSA');
    $scope.claimOpenStatus = claimOpen;
    $scope.claimClosedStatus = claimClosed;
    $scope.openStatus = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState').getCode('open').code;
    $scope.isAgreed = false;
    $scope.isSaved = false;
    $scope.repairerOnlyPSA = !ApplicationFeatures.hasFeature('role.producer') && ApplicationFeatures.hasFeature('role.vendor');

    const ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        //UCWAR-2751
        $scope.countClick= 0;
        $scope.claimNumber = $stateParams.claimNumber;
        $scope.details = {
            claim: null,
            notes: [],
            activities: null,
            reporter: null,
            claimLosslocation: null,
            claimPrimaryContact: null,
            selectedVehicleIncident: null,
            vehicles: null,
            claimContactsVendors: null,
            claimHospitalsDays: null,
            claimDetailsPromiseInvoices: null
        };
        $scope.pageLinks = claimDetailsLinks;



        const claimDetailsPromise = ClaimService.getClaimDetail($stateParams.claimNumber);
        $scope.claimDetailsPromise = claimDetailsPromise;

        var myApp = angular.module('myApp', []);

        // Create the factory that share the Fact
        myApp.factory('Fact', function () {
            return { Field: 'hi Hassan Mansour' };
        });


        claimDetailsPromise.then(
            (claimDetails) => {

                $scope.claimStatus = claimDetails.claimState
                if (typeof ClaimService.addRecentlyViewedClaim === 'function') {
                    ClaimService.addRecentlyViewedClaim($stateParams.claimNumber); // Error handling? Who cares, user already sees the data.
                }

                const pa = claimDetails.lobs.personalAuto;
                if (pa && pa.vehicleIncidents[0]) {
                    pa.vehicleIncidents[0].selected = true;
                    $scope.details.selectedVehicleIncident = pa.vehicleIncidents[0];
                }
                $scope.details.claim = claimDetails;
                $scope.details.activities = claimDetails.activities || {};
                $scope.details.reporter = ctrl._getReporter(claimDetails);
                $scope.details.claimLosslocation = ctrl._getLossLocation(claimDetails);
                $scope.details.claimPrimaryContact = ctrl._getPrimaryContact(claimDetails);
                $scope.details.vehicles = ctrl._getInvolvedVehicles(claimDetails);
                $scope.details.claimContactsVendors = claimDetails.vendors;
                $scope.details.claimHospitalDays = claimDetails.hospitalDays;
                $scope.details.firstVehicleMake_PSA = makeTypelistPSA.getCode(claimDetails.lobs.puw_PSA.vehicles[0].make).name; // PSA
                $scope.details.causeSubgroup_PSA = causeSubgroupTypelistPSA.getCode(claimDetails.causeSubgroup_PSA).name; // PSA
                $scope.details.defaultSubgroup_PSA = defaultSubgroupTypelistPSA.getCode(claimDetails.defaultSubgroup_PSA).name; // PSA
                $scope.canAddInvoiceToServiceRequest = claimDetails.canAddInvoiceToServiceRequest
                $scope.claimState = claimDetails.claimState
                $scope.serviceRequestNumber = claimDetails.serviceRequestNumber


                $scope.details.claimContactsWithoutAgent = []; // Get all the contacts apart from the agent
                for (let i = 0; i < claimDetails.claimContacts.length; i++) {
                    if (claimDetails.claimContacts[i].contactRoles.indexOf('agent') === -1) {
                        const con = {
                            contactLink: claimDetails.claimContacts[i],
                            role: ctrl.getRoleInvolvement(claimDetails.claimContacts[i])
                        };
                        $scope.details.claimContactsWithoutAgent.push(con);
                    }
                }

                // These are part of the documents directive, but the view doesn't load until now and so it won't work otherwise
                angular.element('#uploadButton2').hide();
                angular.element('#uploadButton').show();
            },
            (error) => {
                console.error('error retrieving claim details', error);
            }
        );

        if ($scope.serviceRequestNumber) {
            const serviceRequestPromise = ServiceRequestService.getServiceRequestDetails($scope.serviceRequestNumber);
            $scope.serviceRequestPromise = serviceRequestPromise;
            serviceRequestPromise.then(
                (serviceRequestPromise) => {
                    $scope.serviceRequest = serviceRequestPromise;
                    if ($scope.serviceRequest.invoices.length != 0) {
                        $scope.invoiceStatus = $scope.serviceRequest.invoices[0].status // A service request always has only one invoice
                    }
                },
                (error) => {
                    console.error('error retrieving claim details', error);
                }
            );
        }


        const notesPromise = ClaimService.getClaimNotes($scope.claimNumber);
        notesPromise.then(
            (notes) => {
                $scope.details.notes = notes;
            },
            (error) => {
                console.error('note retrieval failed', error);
            }
        );

        $scope.url = decodeURIComponent($location.url());
        if (typeof $scope.url === 'string' && $scope.url.split('?').length > 1) {
            let params = $scope.url.split('?');
            let eachParamsArr = params[1].split('&');
            $scope.urlParams = {};
            if (eachParamsArr && eachParamsArr.length) {
                eachParamsArr.map(param => {
                    let keyValuePair = param.split('=')
                    let key = keyValuePair[0];
                    let value = keyValuePair[1];
                    $scope.urlParams[key] = value;
                })
            }
            $scope.serviceQuoteId = $scope.urlParams.serviceQuoteId;
            console.log("Service quote ID: " + $scope.serviceQuoteId);
        }

        if ($scope.serviceQuoteId != undefined) {
            //ModalService.showError('gateway.views.modal.Error', 'platform.widgets.openclaim.templates.The quote update feature is unavailable');
            const operation = ClaimService.getServiceQuoteInfo($scope.serviceQuoteId);
            operation.then((result) => {
                if (result != undefined) {
                    $scope.isServiceBoxInfoPresent = true;
                    $scope.isAgreed = (result.isAgreed !== undefined && result.isAgreed === true ) ? true : false;
                    $scope.isSaved = (result.isSaved !== undefined && result.isSaved === true ) ? true : false;
                    $scope.totalAmount = result.totalAmount;
                    $scope.totalVAT = result.totalVAT;
                    $scope.totalTTC = result.totalTTC;

                    $scope.parts = result.parts;
                    $scope.partsTotalAmount = result.partsTotalAmount;
                    $scope.partsTotalDiscount = result.partsTotalDiscount;
                    $scope.partsTotalVAT = result.partsTotalVAT;
                    $scope.partsTotalTTC = result.partsTotalTTC;

                    $scope.operations = result.operations;
                    $scope.operationsTotalAmount = result.operationsTotalAmount;
                    $scope.operationsTotalDiscount = result.operationsTotalDiscount;
                    $scope.operationsTotalVAT = result.operationsTotalVAT;
                    $scope.operationsTotalTTC = result.operationsTotalTTC;
                    //UCWAR-2751
                    var serboxClick = angular.element("[heading='Service Box']");
                    if(serboxClick !== undefined){
                        serboxClick.click();
                    }
                }
            }).catch((error) => {
                ModalService.showError('gateway.views.modal.Error', 'quoteandbind.common.flow.error.An error has occurred...');
            });
        } else {
            $scope.isServiceBoxInfoPresent = false;
        }

        return this;
    };

    ctrl.defineWatches = () => {
        $scope.$watch('selectedVehicleIncident', (vehicleIncident) => {
            if (vehicleIncident) {
                $scope.details.selectedVehicleCoverages = ctrl._getSelectedVehicleCoverage($scope.details.claim, vehicleIncident.publicID);
            }
        });
    };

    ctrl.defineWatches = () => {
        $scope.$watch('serviceRequestPromise', () => {
            $scope.serviceRequest = $scope.serviceRequestPromise;
        });
    };

    ctrl.selectVehicle = (selectedVehicleIncident) => {
        const pa = $scope.details.claim.lobs.personalAuto;
        if (!pa) {
            return;
        }
        const incident = _.find(pa.vehicleIncidents, (vehIncident) => {
            return vehIncident.publicID === selectedVehicleIncident.publicID;
        });
        if (incident) {
            incident.selected = true;
            $scope.details.selectedVehicleIncident = incident;
            for (const i in pa.vehicleIncidents) {
                if (pa.vehicleIncidents[i].publicID !== incident.publicID) {
                    pa.vehicleIncidents[i].selected = false;
                }
            }
        }
    };

    ctrl.getSelectedVehicleClass = (isActive) => {
        if (isActive) {
            return 'activeVehicle';
        }
        return '';
    };

    ctrl.getStateLabel = () => {
        if ($scope.details.claim && $scope.details.claim.claimState) {
            const typeKey = claimStateTypelist.getCode($scope.details.claim.claimState);
            //UCWAR-2751
            if($scope.isServiceBoxInfoPresent == true && $scope.serviceQuoteId != undefined){
                var ServiceBoxClick = angular.element("[heading='Service Box']");
                if( ServiceBoxClick.length > 0 && $scope.countClick == 0){
                    ServiceBoxClick.click(); $scope.countClick = 1;
                }
            }
            return typeKey ? typeKey.name : null;
        }
        return null;
    };

    ctrl.getRoleInvolvement = (claimContact) => {
        const roles = [];
        if (claimContact && claimContact.contactRoles && claimContact.contactRoles.length > 0) {
            claimContact.contactRoles.forEach((contactRoleCode) => {
                const contactRole = contactRoleTypelist.getCode(contactRoleCode);
                if (contactRole) {
                    roles.push(contactRole.name);
                }
            });
            return roles.join(', ');
        }
    };

    ctrl.getDisplayName = (contact) => {
        return contact ? contact.displayName : $filter('translate')('claim.controllers.ClaimDetailsCtrl.Unknown');
    };

    ctrl.createNote = () => {
        $state.go('createNote', {
            claimNumber: $stateParams.claimNumber
        });
    };

    ctrl._getSelectedVehicleCoverage = (claimDetails, selectedPublicID) => {
        const selectedCovs = [];
        for (const i in claimDetails.exposures) {
            if (claimDetails.exposures.hasOwnProperty(i)) {
                const pa = claimDetails.exposures[i].lobs.personalAuto;
                if (pa && pa.vehicleIncident.publicID === selectedPublicID) {
                    const coverage = {
                        'Type': '',
                        'Status': ''
                    };
                    if (claimDetails.exposures[i].coverageType) {
                        coverage.Type = coverageTypeTypelist.getCode(claimDetails.exposures[i].coverageType).name;
                    } else {
                        coverage.Type = '-';
                    }
                    coverage.Status = claimDetails.exposures[i].exposureState;
                    selectedCovs.push(coverage);
                }
            }
        }
        return selectedCovs;
    };

    ctrl._getPrimaryContact = (claimDetails) => {
        return claimDetails.mainContact ? claimDetails.mainContact.displayName : null;
    };

    ctrl._getReporter = (details) => {
        if (details.claimReporter.reportedBy) {
            return details.claimReporter.reportedBy.displayName;
        }
        return $filter('translate')('claim.controllers.ClaimDetailsCtrl.Unknown');
    };

    ctrl._getLossLocation = (claimDetails) => {
        const location = claimDetails.lossLocation ? claimDetails.lossLocation.displayName : '';
        location.replace('\n', ', ');
        return location;
    };

    ctrl._getInvolvedVehicles = (claimDetails) => {
        /**
         * For vehicles that exist on the policy, add the vehicle and its coverage
         * to a collection. The collection should only contain vehicles that
         * are involved in the claim.
         */

        // create a list of the VIN's involved on the claim
        const involvedVINarray = [];
        const involvedVehicles = [];
        const pa = claimDetails.lobs.personalAuto;
        const papolicy = claimDetails.policy.lobs.personalAuto;
        if (!pa) {
            return [];
        }
        if ((pa.vehicleIncidents === null) || (pa.vehicleIncidents.length < 1) || (claimDetails.policy === null) || (papolicy.vehicles === null)) {
            return involvedVehicles;
        }
        for (let i = 0; i < pa.vehicleIncidents.length; i++) {
            involvedVINarray.push(pa.vehicleIncidents[i].vehicle.vIN);
        }
        for (let x = 0; x < papolicy.vehicles.length; x++) {
            if (involvedVINarray.indexOf(papolicy.vehicles[x].vIN) !== -1) {
                involvedVehicles.push(papolicy.vehicles[x]);
            }
        }
        return involvedVehicles;
    };

    ctrl.canAccessFinancials = () => {
        return ApplicationFeatures.hasFeature('role.producer') && ApplicationFeatures.hasFeature('financials');
    };

    ctrl.isVendor = () => {
        return ApplicationFeatures.hasFeature('role.vendor');
    };

    ctrl.disAgree = () => {
        console.log(" disagree method called");
                const operation = ClaimService.disagreeQuoteFromServiceBox($scope.serviceQuoteId, $scope.details.claim.claimNumber);
                operation.then((result) => {
                    console.log(result);
                    if(result == "Disagree") {
                        $scope.isAgreed = true;
                    }
                    else {
                       ModalService.showInfo('', { result });
                    }
                })
    }

    ctrl.saveServiceBoxDataForOpenClaim = () => {
        console.log("In save service box for open claim.");
        if ($scope.details.claim.claimState == 'closed') {
            ModalService.showError('gateway.views.modal.Error', 'platform.widgets.openclaim.templates.The claim is closed');
        } else if ($scope.details.claim.claimState == 'open') {
            if ($scope.details.claim.checks.length > 0) {
                ModalService.showError('gateway.views.modal.Error', 'platform.widgets.openclaim.templates.The claim is on closing process');
            } else if ($scope.details.claim.serviceRequests.length > 0 && $scope.details.claim.serviceRequests.filter(function (e) { return e.status === 'canceled'; }).length > 0) {
                ModalService.showError('gateway.views.modal.Error', 'platform.widgets.openclaim.templates.The service box details cannot be updated');
            } else if ($scope.details.claim.serviceRequests.length > 0 && ctrl.countRepairerService() > 1) {
                ModalService.showError('gateway.views.modal.Error', 'platform.widgets.openclaim.templates.The service box details cannot be updated');
            }
            else {
                const operation = ClaimService.saveServiceBoxDataForOpenClaim($scope.serviceQuoteId, $scope.details.claim.claimNumber);
                operation.then((result) => {
                    if (result != undefined) {
                        ModalService.showInfo('', { result });
                        console.log("open claim cc service call completed.");
                        if(result == "Quote has been revised successfully"){
                            $scope.isSaved = true;
                        }
                    }
                }).catch((error) => {
                    ModalService.showError('gateway.views.modal.Error', 'quoteandbind.common.flow.error.An error has occurred...');
                });
            }
        }
    }
    ctrl.countRepairerService = function () {
        let count = 0;
        //UCWAR-2794
        $scope.details.claim.serviceRequests.forEach(function(service){
            service.services.forEach(function(e){
                if(e == "Repair work" || e == "Travaux de réparation" 
                    || e == "Servizi di riparazione" || e == "Trabajos de reparación"){
                        count++; console.log(e)
                }
            })
        })
        return count;
    }
    ctrl.isAgreedTrue = ()=>{
        return $scope.isAgreed == true;
    }
    ctrl.isSavedTrue = ()=>{
        return $scope.isSaved == true;
    }
    ctrl.getBackToPreviousState = () => {
        let previousState = $scope.pageLinks.previousPage;
        let previousParams = null;

        const navigationHistory = NavigationService.recentHistory();
        if (navigationHistory) {
            const historyFrom = navigationHistory.from;
            previousState = historyFrom.state.name;
            previousParams = historyFrom.params;
        }

        $state.go(previousState, previousParams);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', 'claim.ClaimService', '$state', '$stateParams', '$location', 'InsuranceSuiteMetadata', 'claimDetailsLinks', 'NavigationService', 'servicerequest.ServiceRequestService', 'ModalService'];

export default fn;
